import type { SVGProps } from 'react';

import * as Illustrations from './illustrations';

export type IllustrationName = keyof typeof Illustrations;

type IllustrationProps = SVGProps<SVGSVGElement> & {
  name: IllustrationName;
  strokeWidth: number;
};

export const Illustration = ({ name, strokeWidth, ...delegated }: IllustrationProps) => {
  const Component = Illustrations[name];

  return <Component {...delegated} aria-hidden={delegated['aria-hidden'] ?? true} strokeWidth={strokeWidth} />;
};
